import React from 'react';
import {  Grid, Row, Col, Image, Button, Alert, Modal, Tabs, Tab, FormGroup, ControlLabel, FormControl, ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import {goTo, FieldGroup} from '../../GlobalTools';
import Select from 'react-select';


const ItemShareView = ({
    items,
    list,
    userActivity,
    toggleWriteReviewModal,
    reviews,
    count_reviews,
    reviews_options,
    customStyles,
    onChange,
    filter_review,
    messages,
    onChangeSelect,
    select_review,
    count_items,
    isLoading
}) => (
<div className="item share" style={{backgroundColor: '#434345', height: '100%'}}>
    <Grid>
        <Row className="header-logo">
            <Col xs={12}>
                <img src='/assets/img/logo_faver.png' className="center-block" style={{height: "24px"}} />
            </Col>
        </Row>
        <Row>            
            <Col xs={12}>                
                <h1 className="title">{list.name}</h1>
            </Col>
        </Row>
        
        <Row className="row-miniature">
            {                                
                items.map(function(item, index){          
                    return (
                        <Col xs={2} className="miniature" key={index}>
                            <div className="img-miniatures" style={{backgroundImage: item.item_img_url}}>
                            </div>
                        </Col>
                    );
                })
            }
        </Row>
        <Row>
            <Col xs={12}>
                <p className="text-create">List created {list.date} by <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>{list.user_created}</span></p>
            </Col>
        </Row>
        
        <Row className={ items.length>0 ? "content-items" : "content-items-without" }>
        {   
                                     
            items.map(function(item, index){          
                return (                    
                        <Col xs={12} sm={6} md={4} key={index} className="section-item">
                            <Row onClick={() => goTo('/item/'+item.id)} style={{cursor: "pointer"}}>
                                <Col xs={12}>
                                    <div className="background-item" style={{backgroundImage: item.item_img_url}}>
                                        <div className="box-number">{index+1}</div>
                                        <div className="box-text">
                                            <p className="title-item">{item.name}</p>
                                            <p style={{color: "rgba(255, 255, 255, 1)"}}>{item.type}</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mtop-10 mbottom-20">
                                <Col xs={12}>
                                    <div className="col-5 text-center">
                                        <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                            <img src='/assets/img/icons/tiny_faver.png' className="center-block activity-icon" />
                                            <p className="tc-white" style={{display: "inline-block"}}>{item.actions.fave}</p>
                                        </span>
                                    </div>
                                    <div className="col-5 text-center">  
                                        <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>                                     
                                            <img src='/assets/img/icons/tiny disfave.png' className="center-block activity-icon" />                            
                                            <p className="tc-white" style={{display: "inline-block"}}>{item.actions.disfave}</p>
                                        </span>
                                    </div>
                                    <div className="col-5 text-center">
                                        <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                            <img src='/assets/img/icons/tiny share.png' className="center-block activity-icon" />
                                            <p className="tc-white" style={{display: "inline-block"}}>Send</p>
                                        </span>
                                    </div>
                                    <div className="col-5 text-center">
                                        <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                            <img src='/assets/img/icons/tiny add.png' className="center-block activity-icon" />
                                            <p className="tc-white" style={{display: "inline-block"}}>Add</p>
                                        </span>
                                    </div>
                                    <div className="col-5 text-center">
                                        <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                            <img src='/assets/img/icons/tiny save.png' className="center-block activity-icon" />
                                            <p className="tc-white" style={{display: "inline-block"}}>Bucket</p>
                                        </span>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mtop-20">
                                <Col xs={12}>
                                    {item.caption ? 
                                        <p id="description-ellipsis" className="txt-white">{item.caption}</p>
                                    : 
                                        <p id="description-ellipsis" style={{color: "transparent"}}>-</p>
                                    }
                                </Col>
                            </Row>


                            {/*item.caption ? 
                                <Row className="mtop-20 mbottom-20">
                                    <Col xs={12}>
                                        <p id="description-ellipsis">{item.caption}</p>
                                    </Col>
                                </Row>
                            : 
                                '****'
                            */}
                        </Col>
                                      
                );
            })
        }
        </Row> 

        <Row style={{paddingTop: "0", paddingBottom: "90px"}}>
            <Col xs={12} style={{paddingLeft: "0", paddingRight: "0"}}>
                <Tabs defaultActiveKey={2} id="icons_activity">
                    <Tab eventKey={1} title="Activity">
                        <Row className="mtop-20 mbottom-20" style={{borderBottom: "1px solid rgba(255, 255, 255, 0.10)"}}>
                            <Col xs={12}>
                                <div className="col-5 text-center">
                                    <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                        <img src='/assets/img/icons/tiny_faver.png' className="center-block activity-icon" />
                                        <p style={{display: "inline-block"}} className="txt-white">{list.activity_up_faves}</p>
                                    </span>
                                </div>
                                <div className="col-5 text-center"> 
                                    <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>                                       
                                        <img src='/assets/img/icons/tiny disfave.png' className="center-block activity-icon" />
                                        <p style={{display: "inline-block"}} className="txt-white">{list.activity_down_faves}</p>
                                    </span>                                                           
                                </div>
                                <div className="col-5 text-center">
                                    <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                        <img src='/assets/img/icons/tiny share.png' className="center-block activity-icon" />
                                        <p style={{display: "inline-block"}} className="txt-white">{list.activity_sends}</p>
                                    </span>
                                </div>
                                <div className="col-5 text-center">
                                    <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                        <img src='/assets/img/icons/tiny add.png' className="center-block activity-icon" />
                                        <p style={{display: "inline-block"}} className="txt-white">{list.activity_adds_to_list}</p>
                                    </span>
                                </div>
                                <div className="col-5 text-center">
                                    <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                        <img src='/assets/img/icons/tiny save.png' className="center-block activity-icon" />
                                        <p style={{display: "inline-block"}} className="txt-white">{list.activity_bucket}</p>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                        {                                
                            userActivity.map(function(activity, index){          
                                return (
                                    <div className="mtop-10 row-activity" key = {index}>
                                        <Row>
                                            <Col xs={12}>
                                                <div className="col-thumbail activity-thumbail" style={{backgroundImage: activity.activity_image_url}}></div>
                                                <p>{activity.first_name} {activity.last_name}</p>                                    
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            })
                        }
                        {messages.activity ? <p className="text-center txt-white">{messages.activity}</p> : ""}
            
                    </Tab>
                    <Tab eventKey={2} title="Reviews">
                        <Row className="mtop-20">
                            <Col xs={5} sm={9}>
                                <h4 className="bold-700 tc-white">Reviews</h4>
                            </Col>
                            <Col xs={7} sm={3}>
                                <Button className="col-xs-12 btn btn-black" onClick={() => toggleWriteReviewModal(true)}>Write Review </Button>
                            </Col>
                        </Row>

                        {
                            messages.review ? 
                                <p className="text-center mtop-20 txt-white">{messages.review}</p> 
                            : 
                            
                            <Row className="mbottom-70" style={{marginTop: '30px'}}>
                                <Col xs={6} sm={4} md={3}>
                                    <FormGroup controlId="type-fave">
                                        <div className="conten-select">
                                            <FormControl onChange={(obj) => onChangeSelect(obj)} value={select_review} componentClass="select">
                                                <option value="all">All</option>
                                                <option value="up_fave">Faves</option>
                                                <option value="down_fave">Disfaves</option>
                                                <option value="newest">Newest</option>
                                                <option value="oldest">Oldest</option>
                                            </FormControl>
                                        </div>
                                    </FormGroup>   
                                </Col>
                                <Col xs={6} sm={8} md={9}>
                                    <p className="pull-right tc-white" style={{marginTop: "10px"}}>{count_reviews} Fave Reviews</p>
                                </Col>

                                {
                                    isLoading ?                                   
                                        <Col xs={12}>
                                            <img src='/assets/img/spinner-green.gif' className="center-block" width="40px"  />
                                        </Col>                                    
                                    :
                                        ''
                                }
                            </Row>
                        }
                        
                        {
                            reviews.map(function(review, index){          
                                return (
                                    <div className="mtop-20 row-review" key = {index}>
                                        <Row>
                                            <Col xs={7} sm={8}>
                                                <div className="col-thumbail" style={{backgroundImage: review.user_img_url}}></div>
                                                <p>{review.user_id.username}</p>                                    
                                            </Col>
                                            <Col xs={5} sm={4}>
                                                <p className="pull-right">{review.month_review} {review.day_review}, {review.year_review}</p>                                    
                                            </Col>
                                            <Col xs={12} className="text-review">
                                                <p>{review.review}</p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xsOffset={6} xs={3} smOffset={8} sm={2}>
                                                <div className="pull-right">
                                                    <img src='/assets/img/icons/fave_grey_lt.png' className="center-block activity-icon" />
                                                    <p className="tc-white" style={{display: "inline-block"}}>{review.faves.up_fave}k</p>
                                                </div>  
                                            </Col>
                                            <Col xs={3} sm={2}>
                                                <div className="pull-right">
                                                    <img src='/assets/img/icons/disfave_grey_lt.png' className="center-block activity-icon" />                            
                                                    <p className="tc-white" style={{display: "inline-block"}}>{review.faves.down_fave}k</p>
                                                </div>                                
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            })
                        }
                            
                    </Tab>
                </Tabs>
            </Col>                
        </Row>

        <Row>
            <Col xs={12}>
                <nav className="navbar navbar-default navbar-fixed-bottom">
                    <div className="container">
                    <Row className="mtop-20 mbottom-20">
                        <Col xs={12}>
                            <div className="col-5 text-center">
                                <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                    <img src='/assets/img/icons/tiny_faver.png' className="center-block activity-icon" />
                                    <p className="tc-white" style={{display: "inline-block"}}>{list.activity_up_faves}</p>
                                </span>
                            </div>
                            <div className="col-5 text-center">
                                <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>                                      
                                    <img src='/assets/img/icons/tiny disfave.png' className="center-block activity-icon" />                            
                                    <p className="tc-white" style={{display: "inline-block"}}>{list.activity_down_faves}</p>
                                </span>
                            </div>
                            <div className="col-5 text-center">
                                <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                    <img src='/assets/img/icons/tiny share.png' className="center-block activity-icon" />
                                    <p className="tc-white" style={{display: "inline-block"}}>Send</p>
                                </span>
                            </div>
                            <div className="col-5 text-center">
                                <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                    <img src='/assets/img/icons/tiny add.png' className="center-block activity-icon" />
                                    <p className="tc-white" style={{display: "inline-block"}}>Add</p>
                                </span>
                            </div>
                            <div className="col-5 text-center">
                                <span onClick={() => toggleWriteReviewModal(true)} style={{cursor: "pointer"}}>
                                    <img src='/assets/img/icons/tiny save.png' className="center-block activity-icon" />
                                    <p className="tc-white" style={{display: "inline-block"}}>Bucket</p>
                                </span>
                            </div>
                        </Col>
                    </Row>
                    </div>
                </nav>
            </Col>
        </Row>        
    </Grid>
</div>
);

export default ItemShareView;



// WEBPACK FOOTER //
// ./src/client/views/items/ItemShareView.js